import React, { useEffect, useState } from 'react';
import {Property} from "../../../models/Property";
import {API_URL} from "../../../config";
import {Spinner} from "../../common/Spinner";
import {Listing} from "./Listing";

export const Listings: React.FC = () => {
    const [properties, setProperties] = useState<Property[]>([]);

    useEffect(() => {
        fetch(API_URL + 'properties')
            .then((res) => {
                return res.json();
            })
            .then((res: Property[]) => {
                setProperties(res);
            });
    }, []);

    if (properties.length < 1) {
        return <Spinner />;
    }

    return (
        <div className="row">
            {properties.map((property) => {
                return (
                    <Listing
                        property={property}
                    />
                );
            })}
        </div>
    );
};
